export default "__VITE_ASSET__Vmjy_hj0__"